import type { ApiError } from 'utils/http/apiErrorHelper';

export type PriceImprovementResponseActions =
  | PriceImprovementRejected
  | PriceImprovementRejectSucceded
  | PriceImprovementRejectFailed
  | PriceImprovementValidated
  | PriceImprovementValidateSucceded
  | PriceImprovementValidateFailed
  | PriceImprovementResponseCommentChanged
  | PriceImprovementResponseAcceptablePriceAdjustmentChanged
  | PriceImprovementResponseErrorDismissed;

export function priceImprovementRejected(requestForPriceImprovementId: string, quoteId: string, comment?: string) {
  return {
    type: 'PRICE_IMPROVEMENT_REJECTED' as const,
    requestForPriceImprovementId,
    quoteId,
    comment,
  };
}
export type PriceImprovementRejected = ReturnType<typeof priceImprovementRejected>;

export function priceImprovementRejectSucceded(requestForPriceImprovementId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_REJECT_SUCCEDED' as const,
    requestForPriceImprovementId,
  };
}
export type PriceImprovementRejectSucceded = ReturnType<typeof priceImprovementRejectSucceded>;

export function priceImprovementRejectFailed(requestForPriceImprovementId: string, error: ApiError) {
  return {
    type: 'PRICE_IMPROVEMENT_REJECT_FAILED' as const,
    requestForPriceImprovementId,
    error,
  };
}
export type PriceImprovementRejectFailed = ReturnType<typeof priceImprovementRejectFailed>;

export function priceImprovementValidated(
  requestForPriceImprovementId: string,
  quoteId: string,
  priceAdjustment: number,
  comment?: string,
) {
  return {
    type: 'PRICE_IMPROVEMENT_VALIDATED' as const,
    requestForPriceImprovementId,
    quoteId,
    comment,
    priceAdjustment,
  };
}
export type PriceImprovementValidated = ReturnType<typeof priceImprovementValidated>;

export function priceImprovementValidateSucceded(requestForPriceImprovementId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_VALIDATE_SUCCEDED' as const,
    requestForPriceImprovementId,
  };
}
export type PriceImprovementValidateSucceded = ReturnType<typeof priceImprovementValidateSucceded>;

export function priceImprovementValidateFailed(requestForPriceImprovementId: string, error: ApiError) {
  return {
    type: 'PRICE_IMPROVEMENT_VALIDATE_FAILED' as const,
    requestForPriceImprovementId,
    error,
  };
}
export type PriceImprovementValidateFailed = ReturnType<typeof priceImprovementValidateFailed>;

export function priceImprovementResponseCommentChanged(requestForPriceImprovementId: string, comment?: string) {
  return {
    type: 'PRICE_IMPROVEMENT_RESPONSE_COMMENT_CHANGED' as const,
    requestForPriceImprovementId,
    comment,
  };
}
export type PriceImprovementResponseCommentChanged = ReturnType<typeof priceImprovementResponseCommentChanged>;

export function priceImprovementResponseAcceptablePriceAdjustmentChanged(
  requestForPriceImprovementId: string,
  acceptablePriceAdjustment?: number,
) {
  return {
    type: 'PRICE_IMPROVEMENT_RESPONSE_ACCEPTABLE_PRICE_ADJUSTMENT_CHANGED' as const,
    requestForPriceImprovementId,
    acceptablePriceAdjustment,
  };
}
export type PriceImprovementResponseAcceptablePriceAdjustmentChanged = ReturnType<
  typeof priceImprovementResponseAcceptablePriceAdjustmentChanged
>;

export function priceImprovementResponseErrorDismissed(requestForPriceImprovementId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_RESPONSE_ERROR_DISMISSED' as const,
    requestForPriceImprovementId,
  };
}
export type PriceImprovementResponseErrorDismissed = ReturnType<typeof priceImprovementResponseErrorDismissed>;
